import { dsl } from '@wix/yoshi-serverless/wrap';

export const getUploadUrl = dsl({
          functionName: 'getUploadUrl',
          fileName: 'api/media-manager/media-manager.api',
        });